module.exports = __webpack_public_path__ + "static/media/by1.ae7ff1db.svg";